import { createSlice } from "@reduxjs/toolkit";
import { LoyaltyTierSystem } from "../../../utils/loyaltyTypes";
import { fetchLoyaltyTierSystem } from "../http/getLoyaltyTierSystemThunk";

type LoyaltyTierSystemState = {
  data: LoyaltyTierSystem | null;
  restaurantId: number | null;
  requestId: string | null;
  status: "idle" | "loading" | "succeeded" | "failed";
};

const initialState: LoyaltyTierSystemState = {
  data: null,
  restaurantId: null,
  requestId: null,
  status: "idle",
};

const loyaltyTierSystemSlice = createSlice({
  name: "loyaltyTierSystem",
  initialState,
  reducers: {
    clearLoyaltyTierSystem: (state) => {
      state.data = null;
      state.restaurantId = null;
      state.requestId = null;
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoyaltyTierSystem.pending, (state, { meta }) => {
        if (state.restaurantId !== meta.arg.restaurantId) {
          state.data = null;
        }
        state.restaurantId = meta.arg.restaurantId;
        state.requestId = meta.requestId;
        state.status = "loading";
      })
      .addCase(fetchLoyaltyTierSystem.fulfilled, (state, { meta, payload }) => {
        if (
          state.restaurantId !== meta.arg.restaurantId ||
          state.requestId !== meta.requestId
        ) {
          return;
        }
        state.status = "succeeded";
        state.data = payload;
      })
      .addCase(fetchLoyaltyTierSystem.rejected, (state, { meta }) => {
        if (
          state.restaurantId !== meta.arg.restaurantId ||
          state.requestId !== meta.requestId
        ) {
          return;
        }
        state.status = "failed";
      });
  },
});

export const { clearLoyaltyTierSystem } = loyaltyTierSystemSlice.actions;

export default loyaltyTierSystemSlice.reducer;
